/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Constants for lifestyles module
 */

export const DONE_FETCHING_CITY_LIFESTYLES = '@@nzr/cityLifestyles/DONE_FETCHING_LIFESTYLES'
export const ERROR_FETCHING_CITY_LIFESTYLES = '@@nzr/cityLifestyles/ERROR_FETCHING_LIFESTYLES'
export const RECEIVE_CITY_LIFESTYLES = '@@nzr/cityLifestyles/RECEIVE_LIFESTYLES'
export const START_FETCHING_CITY_LIFESTYLES = '@@nzr/cityLifestyles/START_FETCHING_LIFESTYLES'
